homeInfo = {
    init: function () {
        $(".section-home-info").each(function () {
            var section = $(this);

            function setActive(key) {
                if (!key) {
                    key = 1;
                }

                section.find("[data-info-key]").removeClass("active");
                section.find('[data-info-key="' + key + '"]').addClass("active");
            }

            function scrollToSectionStart() {
                if (!window.matchMedia("(max-width: 850px)").matches) {
                    return;
                }

                window.requestAnimationFrame(function () {
                    $("html, body").animate({
                        scrollTop: section.offset().top - 100
                    }, 450);
                });
            }

            section.find(".home-info-card__button").off("click.homeInfo").on("click.homeInfo", function () {
                setActive($(this).closest("[data-info-key]").data("info-key"));
                scrollToSectionStart();
            });

            section.find(".home-info__mobile-nav-item").off("click.homeInfo").on("click.homeInfo", function () {
                setActive($(this).closest("[data-info-key]").data("info-key"));
            });

            setActive(section.find("[data-info-key]").first().data("info-key"));
        });
    }
};

$(document).ready(function () {
    homeInfo.init();
});

$(document).on("shopify:section:load", function () {
    homeInfo.init();
});
